/* Publish by EComposer at 2026-10-21 12:00:15*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-u1pkrpa001"]=  window.__ectimmers["ecom-u1pkrpa001"] || {};
if(!this.$el)return!1;const t=this.$el;if(t.classList.contains("ecom-builder-structure")||t.querySelector(".ecom-builder-structure")){const i=t.querySelector(".ecom-shape-item").getBoundingClientRect();if(i){let s=i.width;s=Math.round(s);const o=t.querySelector(".ec-line-svg");if(o){const n=t.querySelector(".ecom-shape-i");if(n){let _=n.getBoundingClientRect().width;_=Math.round(_),_<s&&(s=_)}o.setAttribute("viewBox","0 0 "+s+" 1");let r=4;o.style.height!==void 0&&o.style.height!==null&&(r=o.style.height.replace("px","")),o.querySelectorAll(".ec-group-ecx").forEach(_=>{if(_){let b=_.getAttribute("d");b&&(o.querySelectorAll(".ec-arrow").length>0?b="M0,"+r/2+"L"+(s-Math.round(r/2))+".96000000000004,"+r/2:b="M0,"+r/2+"L"+(s-1)+".96000000000004,"+r/2,o.querySelectorAll(".ec-arrow-left").length>0&&(b="M"+r/2+","+r/2+"L"+(s-Math.round(r/2))+".96000000000004,"+r/2),_.setAttribute("d",b))}});let l="";o.querySelectorAll(".ec-arrow").forEach(_=>{if(_){let b=_.getAttribute("d");if(b){let y=b.split(",");y[y.length-1].includes("Z")&&(l="Z"),b="M"+Math.round(s-r/2-r*2)+".96,-"+r+"L"+(s-Math.round(r/2))+".96,"+r/2+"L"+(s-Math.round(r/2)-r*2)+".96,"+r*2+l,_.setAttribute("d",b)}}}),o.querySelectorAll(".ec-arrow-left").forEach(_=>{if(_){let b=_.getAttribute("d");if(b){let y=b.split(",");y[y.length-1].includes("Z")&&(l="Z"),b="M"+(r/2+r*2)+",-"+r+"L"+r/2+","+r/2+"L"+(r/2+r*2)+","+r*2+l,_.setAttribute("d",b)}}});let p=o.querySelectorAll(".circle-p");p.length>0&&p.forEach(_=>{_&&(_.setAttribute("r",(r*2).toString()),_.setAttribute("cx",(r*2).toString()),_.setAttribute("cy",(r/2).toString()))});let m=o.querySelectorAll(".circle-right");m.length>0&&m.forEach(_=>{_&&_.setAttribute("cx",(s-r*2).toString())})}}}

                    });
                    
                        document.querySelectorAll('.ecom-u1pkrpa001').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1pkrpa001', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-icnivfmr5oj"]=  window.__ectimmers["ecom-icnivfmr5oj"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-icnivfmr5oj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-icnivfmr5oj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x1hoo8uvjt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x1hoo8uvjt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-enj76hexxft').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-enj76hexxft', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85y078diufx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85y078diufx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-40hy9sc6x5j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-40hy9sc6x5j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mi45vpq6tg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mi45vpq6tg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d6c7266hqw4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d6c7266hqw4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yrdi2j619pl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yrdi2j619pl', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wwtxczterid"]=  window.__ectimmers["ecom-wwtxczterid"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-wwtxczterid"]["ufnc6nyb4"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-wwtxczterid').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wwtxczterid', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s79xf3xgqob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s79xf3xgqob', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bragsw74x9e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bragsw74x9e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2dti470i2wl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2dti470i2wl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-djy7es9wkzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-djy7es9wkzb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8zceigeapwq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zceigeapwq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h3h4frp9b5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h3h4frp9b5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8815fgt5hn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8815fgt5hn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-csnd7869xnt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-csnd7869xnt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r2p74rjnxy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r2p74rjnxy8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o7tuxcu6xp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o7tuxcu6xp', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zsbu66z69o"]=  window.__ectimmers["ecom-zsbu66z69o"] || {};
var $,E,A,j,P,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,s=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,n=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(P=this.settings.disable_effect)!=null?P:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(I=>I.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(I){const D=I.getBoundingClientRect();return D.top>=0&&D.left>=0&&D.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&D.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(I){return o&&I<768||s&&I>767&&I<1025||i&&I>1024}function b(I){if(!I)return;const D=I.style.transition;I.style.transition="none",I.style.height="auto";const R=I.scrollHeight;I.style.height="0px",I.offsetHeight,I.style.transition=D,requestAnimationFrame(()=>{const H=r?"auto":e?R+"px":"auto";I.style.height=H})}function y(I){I.classList.remove("ecom-item-active");const D=I.querySelector(":scope > .ecom-accordion__body");D&&(r||(D.style.height=D.scrollHeight+"px",D.offsetHeight),requestAnimationFrame(()=>{D.style.height="0px"}))}function v(I){let D=0;if(I.offsetParent)do D+=I.offsetTop;while(I=I.offsetParent);return D}function w(I){const D=Math.max(0,I),R=window.pageYOffset||document.documentElement.scrollTop,H=D-R;if(H===0)return;const V=300;let K=null;function G(te){K||(K=te);const ne=Math.min((te-K)/V,1),Y=ne<.5?2*ne*ne:1-Math.pow(-2*ne+2,2)/2;window.scrollTo(0,R+H*Y),ne<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function S(I){w(v(I)-100)}function C(I,D=!1){I.forEach((R,H)=>{const V=R.parentNode,K=V.querySelector(":scope > .ecom-accordion__body");!r&&K&&K.classList.add("ecom-effect-accodion");const G=V.classList.contains("ecom-item-active");K&&!a&&(D&&H===0||G)&&requestAnimationFrame(()=>{K.style.height=K.scrollHeight+"px"}),R.onclick=function(te){var ue,_e;if(te.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const ne=m(),Y=this.parentNode,me=Y.parentNode,ce=me.querySelectorAll(":scope > .ecom-accordion__item"),he=Array.from(ce).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const U=this.classList.contains("ecom-item-active"),X=_(ne);if(U)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ce.forEach(y),he.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(ce.forEach(y),he.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),R.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(ue=we.parentElement)==null?void 0:ue.closest)==null?void 0:_e.call(ue,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const Q=this,ge=n||ne>1024;function ee(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(Q)&&S(Q)}if(ge&&!r){let we;const Ae=function(Ee){Ee.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{me.removeEventListener("transitionend",Ae),ee()},50))};me.addEventListener("transitionend",Ae),setTimeout(()=>{me.removeEventListener("transitionend",Ae),ee()},600)}else requestAnimationFrame(()=>{setTimeout(ee,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const I=t.querySelector(".ecom-item-group-init");I&&I.classList.remove("ecom-item-group-init")});function x(){const I=window.location.hash;if(I){const D=t.querySelector(`[data-target="${I}"]`);if(D){D.click(),D.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const V=D.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(V)}}}requestAnimationFrame(()=>{setTimeout(x,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",x,!1)

                    });
                    
                        document.querySelectorAll('.ecom-zsbu66z69o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zsbu66z69o', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f4zxg1bltxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f4zxg1bltxa', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-izec0cur6p"]=  window.__ectimmers["ecom-izec0cur6p"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-izec0cur6p"]["1j7i0486s"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-izec0cur6p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izec0cur6p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 

document.addEventListener('DOMContentLoaded', () => {
            // --- DATA ---
            const imageUrls = [
                'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBWEBBW-25.webp',
                'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBWEBBW-14.webp',
                'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBWEBBW-21.webp',
                'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBWEBBW-27_1.webp',
                'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBWEBBW-17.webp'
            ];
            let currentImageIndex = 0;

            // --- DOM ELEMENTS ---
            const gallery = document.getElementById('gallery');
            const lightbox = document.getElementById('lightbox');
            const lightboxImg = document.getElementById('lightbox-img');
            const lightboxCaption = document.getElementById('lightbox-caption');
            const closeBtn = document.getElementById('close-lightbox');
            const prevBtn = document.getElementById('prev-lightbox');
            const nextBtn = document.getElementById('next-lightbox');
            const moreCount = document.getElementById('more-count');

            // --- INITIALIZE GALLERY ---
            const visibleImages = 3;
            if (imageUrls.length > visibleImages) {
                moreCount.textContent = `+${imageUrls.length - visibleImages}`;
            }

            // --- FUNCTIONS ---
            const showImage = (index) => {
                currentImageIndex = index;
                lightboxImg.src = imageUrls[currentImageIndex];
                lightboxCaption.textContent = `Image ${currentImageIndex + 1} of ${imageUrls.length}`;
            };

            const openLightbox = (index) => {
                lightbox.classList.remove('hidden');
                lightbox.classList.add('flex');
                showImage(index);
            };

            const closeLightbox = () => {
                lightbox.classList.add('hidden');
                lightbox.classList.remove('flex');
            };

            const showNextImage = () => {
                const nextIndex = (currentImageIndex + 1) % imageUrls.length;
                showImage(nextIndex);
            };

            const showPrevImage = () => {
                const prevIndex = (currentImageIndex - 1 + imageUrls.length) % imageUrls.length;
                showImage(prevIndex);
            };

            // --- EVENT LISTENERS ---
            gallery.addEventListener('click', (e) => {
                const target = e.target.closest('.gallery-item, .absolute');
                if (target) {
                    const index = parseInt(target.querySelector('img, span')?.dataset.index || target.dataset.index);
                    if (!isNaN(index)) {
                        openLightbox(index);
                    }
                }
            });

            closeBtn.addEventListener('click', closeLightbox);
            nextBtn.addEventListener('click', showNextImage);
            prevBtn.addEventListener('click', showPrevImage);

            // Close lightbox on clicking the background
            lightbox.addEventListener('click', (e) => {
                if (e.target === lightbox) {
                    closeLightbox();
                }
            });

            // Keyboard navigation
            document.addEventListener('keydown', (e) => {
                if (!lightbox.classList.contains('hidden')) {
                    if (e.key === 'Escape') {
                        closeLightbox();
                    } else if (e.key === 'ArrowRight') {
                        showNextImage();
                    } else if (e.key === 'ArrowLeft') {
                        showPrevImage();
                    }
                }
            });
        });
        

        // This script calculates the current day in the UK and displays the correct opening hours.
        document.addEventListener('DOMContentLoaded', function() {
            const container = document.getElementById('opening-hours-container');
            
            // HTML snippets for different days
            const monThursHTML = `
                <p class="bullet">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; margin-right:6px;">
                        <path d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" fill="black"/>
                        <path d="M10.502 5H9.00195V11L14.252 14.15L15.002 12.92L10.502 10.25V5Z" fill="black"/>
                    </svg>
                    <strong>Open Today:</strong>&nbsp;9AM-10PM
                </p>`;

            const fridayHTML = `
                <p class="bullet">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; margin-right:6px;">
                        <path d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" fill="black"/>
                        <path d="M10.502 5H9.00195V11L14.252 14.15L15.002 12.92L10.502 10.25V5Z" fill="black"/>
                    </svg>
                    <strong>Open Today:</strong>&nbsp;9AM-9PM
                </p>`;
            
            const weekendHTML = `
                <p class="bullet">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; margin-right:6px;">
                        <path d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" fill="black"/>
                        <path d="M10.502 5H9.00195V11L14.252 14.15L15.002 12.92L10.502 10.25V5Z" fill="black"/>
                    </svg>
                    <strong>Open Today:</strong>&nbsp;9AM-7PM
                </p>`;

            try {
                // Get the current date and time in the 'Europe/London' time zone.
                const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
                const day = now.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6

                if (day >= 1 && day <= 4) {
                    // Monday to Thursday
                    container.innerHTML = monThursHTML;
                } else if (day === 5) {
                    // Friday
                    container.innerHTML = fridayHTML;
                } else if (day === 0 || day === 6) {
                    // Saturday or Sunday
                    container.innerHTML = weekendHTML;
                }
            } catch (error) {
                console.error("Could not determine opening hours:", error);
                // Fallback content in case of an error
                container.innerHTML = "<p>Please contact us for opening hours.</p>";
            }
        });

} catch(error){console.error(error);}